// Spanish (es-419, informal "tú") dictionary — assembled from per-domain section files.
// Key tree must stay identical to en.js.
import publicLang from "./es.public";
import funnelLang from "./es.funnel";
import dashboardLang from "./es.dashboard";
import toolsLang from "./es.tools";
import miscLang from "./es.misc";
import fiftyoffLang from "./es.fiftyoff";

const es = {
  locale: "es-ES",
  ...publicLang,
  ...funnelLang,
  ...dashboardLang,
  ...toolsLang,
  ...miscLang,
  ...fiftyoffLang,
};

export default es;
